import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { matchPath } from 'react-router';
import { withRouter } from 'react-router-dom';
import { Player, BigPlayButton } from 'video-react';
import axios from 'axios';
import { API_URL } from '../QRQinectAPI';

import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    // GooglePlusShareButton,
    EmailShareButton
} from 'react-share';
import {
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    // GooglePlusIcon,
    EmailIcon
} from 'react-share';
import "./css/video-react.css";

class View extends Component {
    constructor(props) {
        super(props);
        this.handleNameChange = this.handleNameChange.bind(this);

        this.state = {};
        this.state.Video = props.Video;
        this.DownloadVideo = this.DownloadVideo.bind(this);
        this.renderDownload = this.renderDownload.bind(this);
        let maxVideoHeight = window.innerHeight / 2.3;
        this.state.videoHeight = maxVideoHeight;
        this.state.maxVideoHeight = maxVideoHeight;
        this.state.videoWidth = '100%';
        this.state.maxVideoWidth = '100%';
        this.state.videoLoaded = false;
        this.state.showShareDialog = false;
        this.state.shareURL = window.location.protocol + '//' + window.location.hostname + '/share/' + props.QRCode.GUID;

        this.name = '';
        this.message = '';
    }
    componentDidMount() {
        // calculate when the video will expire
        let creationDate = new Date(this.state.Video.CreationDate);
        let expirationDate = new Date(
            creationDate.getFullYear(),
            creationDate.getMonth(),
            creationDate.getDate() + 60,
            creationDate.getHours(),
            creationDate.getMinutes(),
            creationDate.getSeconds());
        let expiresIn = Math.floor((Date.UTC(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate()) - Date.now()) / (1000 * 60 * 60 * 24));
        this.setState({ expiresIn: expiresIn, expirationDate: expirationDate });

        if (this.refs.player) {
            this.refs.player.subscribeToStateChange(this.handlePlayerStateChange.bind(this));
        }
        // get the width of the video container so we know what our actual max width is.
        // max height will be in this.state.
        let elWidth = (ReactDOM.findDOMNode(this.refs.videoContainer).getBoundingClientRect().width);
        this.setState({ maxVideoWidth: elWidth });

        // let's try and set a CallToAction function on the window.
        if (!window.TrackClickedLink) {
            window.QRGUID = this.props.QRCode.GUID;
            window.TrackClickedLink = function(linkID) {
                // redirect browser to api.qrqinect.com/api/v1/link?LinkID=&QRGUID=
                let Url = API_URL + 'api/v1/link?LinkID=' + linkID + '&QRGUID=' + window.QRGUID;
                fetch(Url);
                return true;
            }
        }
    }
    handlePlayerStateChange(state, prevState) {
        // copy player state to this component's state
        if (!this.state.videoLoaded && state.videoHeight) {
            this.setState({ videoLoaded: true });
            // console.log(state);
            let newWidth;
            let newHeight;
            // determine the appropriate width and height for the video
            if (state.videoHeight > state.videoWidth) {
                // vertical video, set videoHeight to maxHeight, set videoWidth to maxHeight * aspectRatio
                newHeight = this.state.maxVideoHeight;
                newWidth = ((state.videoWidth / state.videoHeight) * newHeight) + 10; // +10 to compensate for left/right padding

            } else {
                // horizontal video, maxWidth, adjust height
                newWidth = this.state.maxVideoWidth;
                newHeight = ((state.videoHeight / state.videoWidth) * newWidth) + 15; // +50 to compensate for bottom padding (50 with code expiration, 15 with just download link)
                if (newHeight > this.state.maxVideoHeight) {
                    this.setState({ maxVideoHeight: newHeight });
                }
            }
            this.setState({ videoHeight: newHeight, videoWidth: newWidth });
        }
        // to be used if we want to trigger an action after the video has ended.
        if (state.ended === true && prevState.ended === false) {
            var AfterVideoAudio = document.getElementById("_AFTER_VIDEO_AUDIO");
            if (AfterVideoAudio) {
                AfterVideoAudio.play();
            }
        }
    }
    DownloadVideo() {
        this.props.history.push('download');
    }
    handleMessageChange(event) {
        this.message = event.target.value;
    }
    handleNameChange(event) {
        this.name = event.target.value;
    }
    SendClientMessage = () => {
        this.setState({error: false});
        // validate the message and name fields
        if (this.message === '') {
            this.setState({error: 'please enter a valid message'});
            return;
        }
        if (this.name === '') {
            this.setState({error: 'please enter your name to continue'});
            return;
        }

        // hide the send button
        this.setState({sending: true});

        const formData = new FormData();
        formData.append('QRCode', this.props.QRCode.GUID);
        formData.append('Name', this.name);
        formData.append('Message', this.message);

        axios.post(API_URL + 'api/v1/sendClientMessage', formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then((response) => {
                this.setState({sent: true});
                // clear the fields, hide them?
            })
            .catch((error) => {
                console.log(error);
                this.setState({ error: "There was an error sending your message, please try again." });
            })
            .finally( () => {
                // show the send button
                this.setState({sending: false});
            })
    }
    /**
     * Override the styles from the index so that this page always shows the correct background
     */
    renderCSS() {
        if(!this.props.objectSettings) {
            console.log(this.props);
            console.log("no prop?");
            return null;
        }
        let obj = this.props.objectSettings;
        return (
            <style dangerouslySetInnerHTML={{
                __html: `
        body {
          color: ${obj.TextColor};
          font-family: '${obj.Font}';
        }
        body:before {
          background-image: unset;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #FFFFFF;
        }
        .button {
          color: ${obj.ButtonTextColor};
          background: ${obj.ButtonColor};
        }
        .primaryTextColor {
          color: ${obj.TextColor};
        }
        .buttonBackgroundColor {
          background: ${obj.ButtonColor};
        }
        .logoImage {
          content: url(${obj.LogoPath});
          width: unset;
          margin: 0 auto;
          height: 30px;
        }
        .CircularProgressbar-path {
          stroke: ${obj.ButtonColor};
          fill: ${obj.ButtonColor};
        }
        .CircularProgressbar-text {
          stroke: transparent;
          fill: ${obj.TextColor};
        }
        .slick-dots li.slick-active button {
          background: ${obj.ButtonColor};
        }
        .navbar {
          color: ${obj.ButtonTextColor};
          //background: ${obj.ButtonColor};
          background: white;
        }
        .site-title h1 {
          color: ${obj.ButtonTextColor};
        }
        .secondaryColor {
          color: ${obj.ButtonColor};
        }
        .container .top {
          background-image: url(${obj.BackgroundPath});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-color: ${obj.BackgroundColor};
        }        
      `}} />
        );
    }

    // renderCSS() {
    //     return (
    //         <style dangerouslySetInnerHTML={{
    //             __html: `

    //         body:before {
    //           background-image: unset;
    //         }
    //       `}} />
    //     );
    // }
    renderDownload() {
        if (true || this.state.expiresIn > 0) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', justifyContent: 'center' }} onClick={this.DownloadVideo}>
                    {/* <span style={{ textAlign: 'center', letterSpacing: '0', fontSize: '11px' }}>VIDEO EXPIRES 60 DAYS FROM ORIGINAL UPLOAD DATE<br /><a>DOWNLOAD</a> VIDEO BEFORE {(this.state.expirationDate.getMonth() + 1) + '/' + this.state.expirationDate.getDate() + '/' + this.state.expirationDate.getFullYear()}</span> */}
                    <span style={{ textAlign: 'center', letterSpacing: '0', fontSize: '11px' }}><a>DOWNLOAD</a> VIDEO</span>
                </div>
            );
        }
        return null;
    }
    renderShare() {
        if (this.state.showShareDialog) {
            return (
                <React.Fragment>
                    <div onClick={() => this.setState({ showShareDialog: false })} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed' }}>
                    </div>
                    <div style={{ width: '100%', backgroundColor: '#fff', position: 'fixed', bottom: '0px', padding: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '10px' }}>
                            <div style={{ width: '40px' }} onClick={ () => {window.TrackClickedLink(2)}}>
                                <FacebookShareButton url={this.state.shareURL}><FacebookIcon size={32} round={true}></FacebookIcon></FacebookShareButton>
                            </div>
                            <div style={{}}>
                                Facebook
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '10px' }}>
                            <div style={{ width: '40px' }} onClick={ () => {window.TrackClickedLink(3)}}>
                                <TwitterShareButton url={this.state.shareURL}><TwitterIcon size={32} round={true}></TwitterIcon></TwitterShareButton>
                            </div>
                            <div style={{}}>
                                Twitter
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '10px' }}>
                            <div style={{ width: '40px' }} onClick={ () => {window.TrackClickedLink(4)}}>
                                <LinkedinShareButton url={this.state.shareURL}><LinkedinIcon size={32} round={true}></LinkedinIcon></LinkedinShareButton>
                            </div>
                            <div style={{}}>
                                Linked In
                            </div>
                        </div>
                        {/* <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '10px' }}>
                            <div style={{ width: '40px' }} onClick={ () => {window.TrackClickedLink(2)}}>
                                <GooglePlusShareButton url={this.state.shareURL}><GooglePlusIcon size={32} round={true}></GooglePlusIcon></GooglePlusShareButton>
                            </div>
                            <div style={{}}>
                                Google Plus
                            </div>
                        </div> */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ width: '40px' }} onClick={ () => {window.TrackClickedLink(5)}}>
                                <EmailShareButton url={this.state.shareURL}><EmailIcon size={32} round={true}></EmailIcon></EmailShareButton>
                            </div>
                            <div style={{}}>
                                Email
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderMiddle() {
        if (this.props.BodyHTML) {
            return (
                // this will need to return a div with 'dangerouslySetInnerHTML' read from the database
                <React.Fragment>
                    <div dangerouslySetInnerHTML={{
                        __html: this.props.BodyHTML
                    }}>
                    </div>
                    <hr />
                </React.Fragment>
            );
        }
    }
    renderPlayer() {
        let otherVideoStatus = ["PENDING", "UPLOADING"]
        if (otherVideoStatus.indexOf(this.state.Video.FilePath) !== -1) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '20%', background: "white", boxShadow: '0 0 10px 1px'}} >
                    <span style={{ textAlign: 'center', padding: "15px"}}>Your Video is currently being processed. Please try again in a few moments.</span>
                </div>
            );
        } else if (this.state.Video.FilePath === "ERROR") {
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '20%', background: "white", boxShadow: '0 0 10px 1px'}} >
                    <span style={{ textAlign: 'center', padding: "15px"}}>There was an error processing your video, please click <a href="video">here</a> to try again.</span>
                </div>
            );
        } else {
            return (
                <div style={{ minWidth: '270px', width: this.state.videoWidth, maxWidth: '100%', height: this.state.videoHeight, maxHeight: this.state.maxVideoHeight, backgroundColor: 'white', padding: '10px', paddingBottom: '15px', boxShadow: '0 0 10px 1px', margin: '0 auto' }}>
                    <Player
                        ref="player"
                        fluid={false}
                        height="100%"
                        width="100%"
                        playsInline
                        src={this.state.Video.FilePath}
                        autoplay={true}
                        poster={this.state.Video.ThumbPath}
                    >
                        <BigPlayButton position="center" />
                    </Player>
                    {this.renderDownload()}
                </div>
            );
        }
    }
    renderRespond() {
        let otherVideoStatus = ["PENDING", "UPLOADING"]
        if (otherVideoStatus.indexOf(this.state.Video.FilePath) !== -1 || this.state.Video.FilePath === "ERROR") {
            return null;
        } else {
            return (
                <React.Fragment>
                    <div style={{ minWidth: '270px', width: this.state.videoWidth, maxWidth: '100%', margin: '10px auto', backgroundColor: 'unset', padding: '5px', borderRadius: '4px' }}>
                    <div className="">Want to say thanks? Reply below.</div>
                        <div className="chatBubble">
                            <textarea ref="messageField" id="message" style={{border: 'none', outline: 'none', resize: 'none', height: '60px'}} onChange={event => this.handleMessageChange(event)}></textarea>
                            <div className="chatBubbleArrow"></div>
                        </div>
                        <div className="">From:</div>
                        <input ref="nameField" id="name" type="text" className="validate chatBubble" style={{backgroundColor: '#dddddd', borderRadius: '5px', border: 'none', paddingLeft: '5px', paddingRight: '5px', width: 'calc(100% - 10px)'}} onChange={event => this.handleNameChange(event)}></input>
                        {this.renderError()}
                        {this.renderSend()}
                    </div>
                </React.Fragment>
            );
        }
    }
    renderSend() {
        if(this.state.sent) {
            return (
                <div >Your message has been sent.</div>
            );
        } else if (this.state.sending) {
            return (
                <div >sending...</div>
            );
        } else {
            return (
                <button className="button" style={{marginBottom: '12px'}} onClick={this.SendClientMessage}>SEND</button>
            );
        }
    }
    renderError() {
        if (this.state.error) {
            return (
                <div style={{color: 'red'}}>{this.state.error}</div>
            );
        }
    }
    render() {
        return (
            <div>
                {this.renderCSS()}
                <div className="navbar">
                    <div className="container">
                        <div className="panel-control-left" style={{ visibility: 'hidden' }}>
                            <a onClick={() => this.setState({ showShareDialog: true })}><i className="fa fa-share-alt secondaryColor" style={{color: this.props.objectSettings.ButtonColor, fontSize: '26px'}}> </i></a>
                        </div>
                        <div className="site-title">
                            <div className="logoImage"></div>
                            {/* <img src={require("./img/logo_gray_green.png")} alt='' style={{ height: '30px' }} /> */}
                        </div>
                        <div className="panel-control-right">
                            <a onClick={() => this.setState({ showShareDialog: true })}><i className="fa fa-share-alt secondaryColor" style={{color: this.props.objectSettings.ButtonColor, fontSize: '26px'}}> </i></a>
                        </div>
                    </div>
                </div>
                <div className="login_register" style={{ height: '100%' }}>
                    <div ref="videoContainer" className="container">
                        <div className="top" style={{ padding: '15px' }}>
                            {this.renderPlayer()}
                            {/* <div className="middle" style={{ margin: '0 auto', maxWidth: '450px' }}>
                                {this.renderMiddle()}
                            </div>
                            {this.renderRespond()}
                            <a href="https://saymorecards.com" target="_blank"><div className="logoImage"></div></a> */}
                        </div>
                        <div className="middle" style={{ margin: '0 auto', maxWidth: '450px' }}>
                            {/* <div style={{ textAlign: 'center', padding: '15px' }}>
                                <img onClick={() => this.setState({ showShareDialog: true })} src={require("./img/Assetshare@2x.png")} alt='' style={{ maxHeight: "40px", maxWidth: "40px", width: 'auto', height: 'auto', margin: '0 auto' }} />
                            </div> 
                            <hr /> */}
                            {this.renderMiddle()}
                        </div>
                        <div className="bottom" style={{ margin: '0 auto', maxWidth: '450px' }}>
                            {this.renderRespond()}
                            {/* <a href="https://saymorecards.com" target="_blank"><div className="logoImage"></div></a> */}
                        </div>
                    </div>
                </div>
                {this.renderShare()}
            </div>
        );
    }
}
export default withRouter(View);


// WEBPACK FOOTER //
// ./src/components/View.js